export const SelectionCardDefaultConfig = {
  imageUrl: '',
  title: '',
  subTitle: '',
  selected: false,
  selectable: true
};
